import { errorCodes } from 'router5';
import { navigateToProductActionSaga } from '../../redux-module';
export var fetchRoutePlugin = function (router) { return ({
    onTransitionError: function (toState, fromState, error) {
        var store = router.getDependencies().store;
        if (error.code === errorCodes.ROUTE_NOT_FOUND && error.route) {
            var _a = error.route, name_1 = _a.name, params = _a.params, opts = _a.opts;
            router.cancel();
            store.dispatch(navigateToProductActionSaga({
                routeName: name_1,
                routeParams: params,
                additionalParams: opts,
            }));
        }
    },
}); };
